module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch08"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle3"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ch_08"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ILLA")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LACK")])])])]), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote#footnote8",
      "id": "fn8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T WAS THANKS TO")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENNON THAT")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("GOT MY BIG BREAK IN MUSIC.")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FIRST MET")]), _vm._v(" J"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OHN WHEN")]), _vm._v(" I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WAS FIFTEEN YEARS OLD AND ATTENDING THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NFIELD")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OMMERCIAL")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OLLEGE.")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("Y GIRLFRIEND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AULINE SAID TO ME THAT YOU REALLY")]), _vm._v(" ought to come down and see my boyfriend play at the Iron Door, which was a sort of glorified youth club there at Anfield. Well, her boyfriend was George Harrison and the band was the Beatles. We went in a crowd of girls from the school, and they all said to the boys onstage, “Give Cilla a go!” because I had been singing at lunch parties and clubs in Liverpool, wherever I could, so they said, “Let her have a go!” and from the stage John said “Okay, Cyrill”—he called me “Cyrill,” the man’s name, he was always calling me that, his little joke because of course he knew my real name—John said, “Okay Cyrill, show us what you’ve got!” So I got up and sang a version of [Gershwin’s] “Summertime,” the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Porgy & Bess")]), _vm._v(" number.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some time afterward I was at the Majestic Ballroom in Birkenhead, and Brian Epstein came up to me and said, “I’ve never heard you sing, I want you to sing with the boys tonight.” So I sang “Summertime” again, with the Beatles playing behind me, but I was terribly, terribly nervous, and Brian was not at all impressed, and I thought, well okay, that’s that, I’ll just be singing around the clubs in Liverpool.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A few months later I was singing in a club called the Blue Angel and after I finished my set Brian came up to me and said, “Why didn’t you sing like that at the Majestic Ballroom?” I had no idea he was even in the club that night, but he loved what he heard and asked to manage me right then. I later asked Ringo if he had asked Brian to give me another listen, because Ringo and I were friends, but he just looked at me and said, “It wasn’t me, it was John.” I thank him to this day, because but for John, Brian never would have given me a second shot after that awful first audition. It truly changed my life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He did stuff like that, which you’d think was totally out of character for him, because he liked to put on this angry young man front, you know, a man’s man, aloof, but behind that was a very warmhearted guy, and really quite shy, and with an acid sense of humor. I remember I did a big TV special, called “Around the Beatles.” I sang a song John and Paul had given me, “Love of the Loved,” while standing at the top of a flight of steps and wearing a very short miniskirt. Sitting at the bottom of the steps were the Beatles, and afterward, during the applause, John whispered mischievously in my ear, “I could see tomorrow’s washing,” meaning he could see my underthings, of course, and normally I’d have been mortified, but there I was on TV, so I just laughed. He was always trying to throw you like that.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14042ef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch08.vue
// module id = 93
// module chunks = 0